import styled from "styled-components";

export const ProgressBarWrapper = styled.div`
  background: #fff;
  border: 1px solid #e8eee5;
  border-radius: 18px;
  padding: 24px 26px;
  box-shadow: 0 4px 18px rgba(28,38,52,0.04);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0;
    width: 5px;
    height: 100%;
    background: linear-gradient(180deg, #509540, #6dd05a);
  }

  & > div {
    background: transparent;
    box-shadow: none;
    border-radius: 0;
    padding: 0;
    gap: 18px;
    align-items: center;

    h2 {
      font-size: 18px;
      font-weight: 800;
      color: #1C2634;
      white-space: nowrap;
      font-family: 'Poppins', sans-serif;
      letter-spacing: -0.3px;
    }

    .pb-percent {
      font-size: 14px;
      font-weight: 800;
      color: #509540;
      font-family: 'Poppins', sans-serif;
      white-space: nowrap;
      min-width: 42px;
      text-align: right;
    }
  }

  p {
    font-size: 13.5px;
    text-align: left;
    color: #666;
    padding: 14px 0 0 0;
    margin: 0;
    line-height: 1.65;
    font-family: 'Poppins', sans-serif;
  }

  @media only screen and (max-width: 768px) {
    padding: 18px 18px 18px 22px;
    p { font-size: 12.5px; line-height: 1.55; }
    & > div {
      flex-direction: column;
      align-items: stretch;
      gap: 12px;
      h2 { font-size: 16px; }
    }
  }
`;

export const ProgressBoxWrapper = styled.div`
  flex: 1;
  background: #eef2eb;
  border-radius: 50px;
  overflow: hidden;
  height: 14px;
  position: relative;

  .progress-bar {
    height: 100%;
    background: linear-gradient(90deg, #509540, #6dd05a);
    transition: width 0.8s ease;
    border-radius: 50px;
    box-shadow: 0 2px 8px rgba(80,149,64,0.30);
  }
`;
